import React, { FunctionComponent } from 'react';
import { Container } from '@material-ui/core';
import MergedPayment from '../../../commonSteps/payment/components/MergedPayment';
import { GetDeal_deal } from '../../../common/graphql/queries/__generated__/GetDeal';
import paymentPageStyles from './paymentPageStyles';

export interface IPaymentPage {
  deal?: GetDeal_deal;
  showCheckoutButton?: boolean;
}

const MergedPaymentPage: FunctionComponent<IPaymentPage> = ({ deal, showCheckoutButton }) => {
  const styles = paymentPageStyles();

  return (
    <Container data-test={'container:checkout:payment'} className={styles.container}>
      <MergedPayment deal={deal} showCheckoutButton={showCheckoutButton} />
    </Container>
  );
};

export default MergedPaymentPage;
